// //https://www.bezkoder.com/jwt-vue-vuex-authentication/
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueCryptojs from "vue-cryptojs";
import VueMask from "v-mask";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import Vue2Filters from "vue2-filters";
import VueNumeric from "vue-numeric";
import VueQuillEditor from "vue-quill-editor";
import VueApexCharts from "vue-apexcharts";
import VuetifyConfirm from "vuetify-confirm";
import VueJsModal from "vue-js-modal";
import VueClipboard from "vue-clipboard2";
// import Confirm from '@/components/Confirm.vue'

require("vue2-dropzone/dist/vue2Dropzone.min.css");
require("@/styles/style.scss");
require("quill/dist/quill.core.css");
require("quill/dist/quill.snow.css");
require("quill/dist/quill.bubble.css");

Vue.config.productionTip = false;

Vue.config.productionTip = false;
Vue.use(VueCryptojs);
Vue.use(VueMask, {
  placeholders: {
    // "#": null, // passing `null` removes default placeholder, so `#` is treated as character
    D: /\d/, // define new placeholder
    Я: /[\wа-яА-Я]/, // cyrillic letter as a placeholder
  },
});
Vue.use(VueMask);
Vue.use(VueMoment, {
  moment,
});
Vue.use(VueNumeric);
Vue.use(VueQuillEditor /* { default global options } */);
Vue.use(VueApexCharts);
Vue.use(VuetifyConfirm, { vuetify });
Vue.use(Vue2Filters);
Vue.use(VueClipboard);
Vue.use(VueJsModal, {
  dialog: true,
  dynamicDefaults: {
    draggable: true,
  },
});
//   Vue.use(Vue2Filters, {
//   capitalize: {
//     onlyFirstLetter: false
//   },
//   number: {
//     format: '0',
//     thousandsSeparator: ',',
//     decimalSeparator: '.'
//   },
//   bytes: {
//     decimalDigits: 2
//   },
//   percent: {
//     decimalDigits: 2,
//     multiplier: 100,
//     decimalSeparator: '.',
//   },
//   currency: {
//     symbol: '$',
//     decimalDigits: 2,
//     thousandsSeparator: ',',
//     decimalSeparator: '.',
//     symbolOnLeft: true,
//     spaceBetweenAmountAndSymbol: false,
//     showPlusSign: false
//   },
//   pluralize: {
//     includeNumber: false
//   },
//   ordinal: {
//     includeNumber: false
//   }
// });
// Vue.use(Confirm, { vuetify })

Vue.component("apexchart", VueApexCharts);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
